import { useEffect, useState } from 'react';

import Input from 'common-ui/input';
import Modal from 'common-ui/modal';

const CountryModal = ({ isOpen, onClose, onSubmit, country, loading }) => {
  const [name, setName] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (country) {
      setName(country.name || '');
    } else {
      setName('');
    }
    setError('');
  }, [country, isOpen]);

  const handleSubmit = () => {
    if (!name.trim()) {
      setError('Country name is required');
      return;
    }

    onSubmit({ name: name.trim() });
  };

  const handleClose = () => {
    setName('');
    setError('');
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      onOk={handleSubmit}
      title={country ? 'Edit Country' : 'Create Country'}
      okText={country ? 'Update' : 'Create'}
      cancelText="Cancel"
      footer
      closeIcon
      width="400px"
      onOkLoading={loading}
    >
      <div>
        <Input
          label="Country Name"
          required
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            setError('');
          }}
          error={error}
          fullWidth
          placeholder="Enter country name"
        />
      </div>
    </Modal>
  );
};

export default CountryModal;
